import Spinner from "@cloudscape-design/components/spinner"

/**
 * Displayed while protocol PDF extraction is in progress.
 *
 * Shows an animated progress indicator and informs the user that extraction takes up to 10 minutes.
 * The parent component polls for status updates.
 */
const ProtocolExtractingState = () => (
  <div className="protocol-extracting">
    <span className="protocol-extracting-icon">
      <Spinner size="large" />
    </span>
    <h3>Extracting Protocol Data...</h3>
    <p>We're analyzing your protocol document. This usually takes up to 10 minutes.</p>
    <div className="protocol-progress">
      <div className="protocol-progress-bar" />
    </div>
    <p className="protocol-extracting-hint">You'll be notified when extraction is complete.</p>
  </div>
)

export default ProtocolExtractingState
